/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M13.5.75a.75.75 0 0 0-.75-.75H2.25l-.2167.0103C.8923.1193 0 1.0805 0 2.25v19.5l.0103.2167C.1193 23.1077 1.0805 24 2.25 24h19.5l.2167-.0103C23.1077 23.8807 24 22.9195 24 21.75v-4.5l-.0121-.1348A.7502.7502 0 0 0 22.5 17.25v4.5l-.0121.1348a.7502.7502 0 0 1-.7379.6152H2.25l-.1348-.0121A.7502.7502 0 0 1 1.5 21.75V2.25l.012-.1348A.7502.7502 0 0 1 2.25 1.5h10.5l.1348-.012A.7502.7502 0 0 0 13.5.75Zm9.7061 4.351a.7501.7501 0 0 0-.0868-.9568l-.1038-.0868a.7502.7502 0 0 0-.9568.0868l-8.4397 8.4382-4.1137-4.1127-.1039-.0868a.75.75 0 0 0-.9568 1.1474l5.1746 5.1747 9.5001-9.5002.0868-.1038Z"
    clipRule="evenodd"
  />,
  'Select'
);
